import {createAction} from '../../core/AppUtils';
import {AdminVideoRepository} from '../../core/repository';

export const ModuleEvents = {
  FETCH_ALL_VIDEO: 'FETCH_ALL_VIDEO',
  UPLOAD_VIDEO: 'UPLOAD_VIDEO',
  DELETE_VIDEO:'DELETE_VIDEO',
  UPDATE_TITLE:'UPDATE_TITLE',
  REARRANGE_CONTENT:'REARRANGE_CONTENT',
  FETCH_SUBTITLE_LIST: 'FETCH_SUBTITLE_LIST',
  GENERATE_SUBTITLES: 'GENERATE_SUBTITLES',
  FETCH_LANGUAGES: 'FETCH_LANGUAGES',
  REGENERATE_SUBTITLES: 'REGENERATE_SUBTITLES',
  FETCH_SUBTITLE_STATUS: 'FETCH_SUBTITLE_STATUS',
  SET_REGENERATING_VIDEO_ID: 'SET_REGENERATING_VIDEO_ID',
  CHECK_VIDEO_ASSOCIATION: 'CHECK_VIDEO_ASSOCIATION',
  CHECK_VIDEO_ASSOCIATION: 'CHECK_VIDEO_ASSOCIATION',
};

export default {
  fetchVideo: createAction(ModuleEvents.FETCH_ALL_VIDEO, async (params) => {
    const data = await AdminVideoRepository.fetchVideo(params);
    return {...data, params}
  }),
  uploadVideo: createAction(ModuleEvents.UPLOAD_VIDEO, async (params) => {
   return await AdminVideoRepository.adminVideoUpload(params);
  },{loading: true, errorMessage: 'Error occured while video uploading. Please try again.' }),

  deleteAdminVideo:createAction(ModuleEvents.DELETE_VIDEO, async (params) => {
    const data = await AdminVideoRepository.deleteAdminVideo(params);
    return {...data}
  }),
  networkError: createAction(ModuleEvents.NETWORK_ERROR, error => error),
  loadingStarted: createAction(ModuleEvents.LOADING_STARTED, action => action),
  loadingFinished: createAction(ModuleEvents.LOADING_FINISHED, action => action),

  updateVideoTitle:createAction(ModuleEvents.UPDATE_TITLE, async (params) => {
    const data = await AdminVideoRepository.updateAdminVideoTitle(params);
    return {...data}
  }),

  rearrangeContent:createAction(ModuleEvents.REARRANGE_CONTENT, async(params)=>{
      const data = await AdminVideoRepository.rearrangeContent(params);
      return { ...data, params };
    }),

  fetchCourseSubtitleList: createAction(ModuleEvents.FETCH_SUBTITLE_LIST, async(params)=>{
      const data = await AdminVideoRepository.fetchCourseSubtitleList(params);
      return { ...data, params };
    }),

  generateSubtitles: createAction(ModuleEvents.GENERATE_SUBTITLES, async(params)=>{
      const data = await AdminVideoRepository.generateSubtitles(params);
      return { ...data, params };
    }),

  fetchLanguages: createAction(ModuleEvents.FETCH_LANGUAGES, async(params)=>{
      const data = await AdminVideoRepository.fetchLanguages(params);
      return { ...data, params };
    }),

  regenerateSubtitles: createAction(ModuleEvents.REGENERATE_SUBTITLES, async(params)=>{
      const data = await AdminVideoRepository.regenerateSubtitles(params);
      return { ...data, params };
    }),

  fetchSubtitleStatus: createAction(ModuleEvents.FETCH_SUBTITLE_STATUS, async(id)=>{
      const data = await AdminVideoRepository.fetchSubtitleStatus(id);
      return { ...data, id };
    }),

  setRegeneratingVideoId: createAction(ModuleEvents.SET_REGENERATING_VIDEO_ID, (id) => id),
  checkVideoAssociation: createAction(ModuleEvents.CHECK_VIDEO_ASSOCIATION, async (videoId) => {
    const data = await AdminVideoRepository.checkVideoAssociation(videoId);
    return { ...data }
  }),

  checkVideoAssociation: createAction(ModuleEvents.CHECK_VIDEO_ASSOCIATION, async (videoId) => {
    return await AdminVideoRepository.checkVideoAssociation(videoId);
  }),
};
